import React, { useEffect, useState } from 'react'
import instance from '../../Config/AxiosConfig';

import Cookies from 'js-cookie';
import AddPublications from '../../Components/AddPublications';
import { useDelete } from '../../Context/ApiContext';
import Lottie from 'react-lottie';
import animationData from '../../lotties/ai.json';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

function StepThree({ handleNext, handleBack }) {

    const { showConfirmDialog, deleteResponse } = useDelete();

    const api = '/articles/removeResearcher';

    const [showPublicationModal, setShowPublicationModal] = useState(false);
    const [pub, setPub] = useState([]);
    const [createPub, setCreatePub] = useState('')

    const handlePublicationModalOpen = () => {
        setShowPublicationModal(true);
    };

    const handlePublicationModalClose = () => {
        setShowPublicationModal(false);
    };



    useEffect(() => {

        const userId = Cookies.get('userId')
        instance.get(`/users/get/${userId}`)
            .then(response => {


                const sortedDocuments = response.data.documents.sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate))
                setPub(sortedDocuments);
            })

            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });

    }, [deleteResponse, createPub]);



    const style = {
        height: pub && pub.length > 0 ? "400px" : "auto",
        overflow: pub.length > 0 ? "scroll" : "hidden"
    };

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };


    const [showAiModal, setShowAiModal] = useState(false);
    const handleAiModalOpen = () => {
        setShowAiModal(true);
    };

    const handleAiModalClose = () => {
        setShowAiModal(false);
    };

    const [axes, setAxes] = useState([])
    const [errors, setErrors] = useState([])
    const handleGenerateAxes = async (id) => {

        try {
            const response = await instance.get(`/articles/generateAxes/${id}`)
            console.log("generate axes :", response);

            if (response.data.success == false) {
                setErrors(response.data.error)
            }
            else {
                setAxes(response.data.axes)
            }


        }
        catch (error) {
            console.log(error);
        }

    }



    const [isSubmitting, setIsSubmitting] = useState(false);

    const [checkedItems, setCheckedItems] = useState({});

    //checked interest
    const handleCheckboxChange = (event, axes) => {
        setCheckedItems({
            ...checkedItems,
            [axes.id]: event.target.checked
        });
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        const selectedInterests = Object.keys(checkedItems).filter(id => checkedItems[id]);

        try {
            setIsSubmitting(true);
            const requests = selectedInterests.map(id =>
                instance.get(`/interests/add/${id}`)
            );
            const responses = await Promise.all(requests);

            console.log('Responses:', responses);
            const allSuccessful = responses.every(response => response.status === 200);

            if (allSuccessful) {

                toast.success('Interest added successfully!', {
                    position: "top-center",

                    hideProgressBar: false,

                });


                const axesfiltred = axes.filter(interest => !selectedInterests.includes(interest.id.toString()));
                setAxes(axesfiltred);


                setShowAiModal(false);
                setTimeout(() => {
                    fetchCommunities();
                }, 500);
            }

        } catch (error) {
            console.error('Error adding interests:', error);

        } finally {
            setIsSubmitting(false);
        }
    };

    const handleOpenAi = (id) => {
        handleAiModalOpen()
        handleGenerateAxes(id)


    }
    const [communities, setCommunities] = useState([]); // Communautés liées aux intérêts
    const [showCommunityModal, setShowCommunityModal] = useState(false); // État du modal des communautés

    const handleCommunityModalOpen = () => {
        setShowCommunityModal(true);
    };

    const handleCommunityModalClose = () => {
        setShowCommunityModal(false);
    };
    // communauties liées aux intérêts

    const { interests } = useDelete();
    const fetchCommunities = async () => {

        const token = Cookies.get('token');
        const data = new FormData();
        interests.forEach(interest => data.append('interests[]', 225));

        try {
            const response = await instance.post('/communities/getAllFromInterests', data, token);
                     
            setCommunities(response.data);
            // Afficher le modal des communautés après avoir reçu les données
            setShowCommunityModal(true);
        } catch (error) {
            console.error('Error fetching communities by interest:', error);
        }
    };

    const handleJoin = async (id) => {
        const token = Cookies.get('token');

        try {
            const response = await instance.get(`/communities/join/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.status === 200) {
                toast.success('Successfully joining the community!', {
                    position: "top-right",
                    autoClose: 500,
                    hideProgressBar: false,
                });

                // Filtrer la communauté qui a été rejointe
                setCommunities(prevCommunities => prevCommunities.filter(community => community.id !== id));
            }
        } catch (error) {
            toast.error('Error joining community!', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
            });
            console.error('Error joining:', error);
        }
    };
    return (
        <>
            <div className="main active">
                <form className="mt-4 " >
                    <h3>Publication list : {pub.length} </h3>
                    <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', paddingTop: '10px', paddingBottom: '10px' }}>
                        <button type="button" className="btn btn-sm btn-primary" onClick={handlePublicationModalOpen}>Add Pub</button> </div>

                    <div className="row  scroll-hidden my-5">
                        <div className="col-11 mx-auto">
                            <div className="vstack gap-3">
                                {

                                    pub &&
                                        pub.length !== 0 ? pub.map((item, i) => {
                                            return (
                                                <div className="card p-3" key={i}>
                                                    <div className="d-md-flex justify-content-between align-items-center">

                                                        <div className="mb-2 mb-md-0">

                                                            <p className=" fw-bold" >{item.titleText}</p>
                                                        </div>

                                                        <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                                            <span onClick={() => handleOpenAi(item.id)} >
                                                                <Lottie
                                                                    options={defaultOptions}
                                                                    height={50}
                                                                    width={60}
                                                                />
                                                            </span>

                                                            <button type="button" className="btn btn-danger-soft btn-sm mb-0 ms-3 rounded" onClick={() => showConfirmDialog(api, item.id)}> Remove </button>

                                                        </div>
                                                    </div>


                                                </div>
                                            )
                                        })
                                        : < h5 className='bold fs-5 text-center ' >there is no publication </h5>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between ">
                        <button type="button" className="btn btn-sm btn-secondary" onClick={handleBack}>Back</button>
                        <button type="button" className="btn btn-sm btn-primary" onClick={handleNext}>Next</button>
                    </div>
                </form>
                {showAiModal &&
                    <>


                        <Modal show={showAiModal} onHide={handleAiModalClose} style={{ marginTop: "50px" }}>
                            <Modal.Header closeButton>
                                <Modal.Title>keywords generated from article </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {axes.length > 0 ?

                                    <form className="row g-3 ms-2">

                                        {axes.map((axe, i) => {
                                            return (
                                                <div className="form-check form-check-md my-3" key={i}>
                                                    <input className="form-check-input"
                                                        type="checkbox"
                                                        id={`axe-${axe.id}`}
                                                        checked={checkedItems[axe.id] || false}
                                                        onChange={(e) => handleCheckboxChange(e, axe)} />
                                                    <label className="form-check-label" htmlFor={`axes-${axe.id}`}>{axe.name}</label>
                                                </div>

                                            )
                                        })


                                        }
                                    </form>
                                    :
                                    <h6 >{errors}</h6>
                                }
                            </Modal.Body>

                            <Modal.Footer>
                                <Button onClick={handleSubmit} disabled={isSubmitting} type="submit" className="btn btn-primary mb-0">{isSubmitting ? 'Saving...' : 'Save changes'}
                                </Button>

                            </Modal.Footer>


                        </Modal>

                    </>}

                {
                    showCommunityModal &&
                    <>


                        <Modal show={showCommunityModal} onHide={handleCommunityModalClose} style={{ marginTop: "50px" }}>
                            <Modal.Header closeButton>
                                <Modal.Title>join communities</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <form className="row g-3 ms-2">


                                    {errors.length > 0 ? <h6 >{errors}</h6>
                                        :

                                        communities.map((item, index) => {
                                            return (
                                                <div className="card card-body" key={index}>
                                                    <div className="d-md-flex justify-content-between align-items-start">

                                                        <div className="mb-2 mb-md-0">

                                                            <p className="small mb-0" >{item.name}</p>
                                                        </div>

                                                        <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                                            <a class="btn btn-success-soft btn-sm" href="#!" onClick={() => handleJoin(item.id)}> Join </a>
                                                        </div>
                                                    </div>


                                                </div>

                                            )
                                        })


                                    }
                                </form>
                            </Modal.Body>



                        </Modal>

                    </>
                }

                {/* Modal pour la création publication */}
                {showPublicationModal && (
                    <Modal show={showPublicationModal} onHide={handlePublicationModalClose} style={{ marginTop: "50px" }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Create Publication</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <AddPublications showPublicationModal={showPublicationModal} createPub={createPub} setCreatePub={setCreatePub} handlePublicationModalClose={handlePublicationModalClose} />

                        </Modal.Body>




                    </Modal>

                )}
            </div></>
    )
}

export default StepThree